import { Theme } from "@mui/material/styles";
import LottieUtils from "./lottie_utils";

export const progressLottieOptions = (
  theme: Theme,
  animation: any,
  customColor?: string
) => {
  const primaryColor = customColor || theme.palette.primary.main; // make sure color is in format like #XXXXXX, instead of var(XXXX)

  let overrideAnimationData = null;
  const colors = LottieUtils.getAllColors(animation);
  overrideAnimationData = LottieUtils.replaceColors(
    animation,
    Object.fromEntries(colors.map((color) => [color, primaryColor]))
  );

  return {
    loop: true,
    autoplay: true,
    animationData: theme.dtcMode ? overrideAnimationData : animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
};
